import type { IconType } from '@rio-cloud/rio-uikit/Icon';

export function getBookingOverviewResourceIcon(assetType: string | undefined): IconType {
    switch (assetType?.toLowerCase()) {
        case 'bus':
            return 'bus';
        case 'van':
            return 'van';
        case 'car':
            return 'car';
        case 'trailer':
            return 'trailer';
        default:
            return 'truck';
    }
}
